module.exports = __webpack_public_path__ + "img/2@2x.9e88882f.png";